<template>
  <div>
    <router-link class="btn btn-info m-2" :to="`/dashboard/charges`">
      Back to Charge List
    </router-link>
    <card class="card">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Product</label>
              <select class="form-control" v-model="charge.product">
                <option value="withdrawal">Withdrawal</option>
                <option value="ikedc">Ikedc</option>
                <option value="ekedc">Ekedc</option>
                <option value="eedc">Eedc</option>
                <option value="ibedc">Ibedc</option>
                <option value="phedc">Phedc</option>
                <option value="aedc">Aedc</option>
                <option value="kedco">Kedco</option>
                <option value="mtnvtu">Mtnvtu</option>
                <option value="airtelvtu">Airtelvtu</option>
                <option value="9mobilevtu">9mobilevtu</option>
                <option value="glovtu">Glovtu</option>
                <option value="mtndata">Mtndata</option>
                <option value="glodata">Glodata</option>
                <option value="airteldata">Airteldata</option>
                <option value="9mobiledata">9mobiledata</option>
                <option value="multichoice">Multichoice</option>
                <option value="startimes">Startimes</option>
                <option value="smile">Smile</option>
                <option value="transfer">Transfer</option>
                <option value="PAY_WITH_TRANSFER">PAY WITH TRANSFER</option>
                <option value="ZEEP_AND_GO">ZEEP AND GO</option>
              </select>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Fee"
                placeholder="Chrage Fee Amount"
                v-model="charge.fee"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Type</label>
              <select class="form-control" v-model="charge.type">
                <option value="charge">charge</option>
                <option value="commission">Commission</option>
                <option value="tax">Tax</option>
              </select>
            </div>

            <div class="col-md-6">
              <label for="inlineFormInput">Mode</label>
              <select class="form-control" v-model="charge.mode">
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Minimum Amount"
                placeholder="Min Amount (For Withdrawals)"
                v-model="charge.minAmount"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Maximum Amount"
                placeholder="Max Amount (For Withdrawals)"
                v-model="charge.maxAmount"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Agent Category"
                placeholder="Merchant Name"
                v-model="charge.merchantId.merchantName"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="VAT on fee (%)"
                placeholder="VAT on fee"
                v-model="charge.vat"
              >
              </fg-input>
            </div>
          </div>

          <div class="row" v-if="charge.mode === 'fixed'">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Total Fee"
                placeholder="Total Fee"
                v-model="charge.totalCharge"
                disabled
              >
              </fg-input>
            </div>
          </div>

          <div class="my-3">
            <p-button type="info" @click.native.prevent="submit" class="mx-4">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Update
            </p-button>
            <p-button type="info" @click.native.prevent="doDelete" class="mx-4">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Delete
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
export default {
  data() {
    return {
      charge: {},
    };
  },
  computed: {
    ...mapState(["loading", "terminal"]),
  },
  methods: {
    ...mapActions(["updateCharges", "deleteCharge"]),
    submit() {
      this.$confirm("Update Charges?").then(() => {
        this.updateCharges(this.charge);
      });
    },
    doDelete() {
      this.$confirm("Delete Charge?").then(() => {
        this.deleteCharge(this.$route.params.chargeId);
      });
    },
    async getCharge() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/charge/${this.$route.params.chargeId}`,
        );
        const { charge } = res.data;
        this.charge = charge;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch Agent Data",
          });
        }
      }
    },
  },
  async mounted() {
    await this.getCharge();
  },
};
</script>
<style></style>
